import { render, staticRenderFns } from "./CareerAiMessageList.vue?vue&type=template&id=52b7bbbc&scoped=true"
import script from "./CareerAiMessageList.vue?vue&type=script&setup=true&lang=ts"
export * from "./CareerAiMessageList.vue?vue&type=script&setup=true&lang=ts"
import style0 from "@/assets/scss/career-ai/career-ai-messages.scss?vue&type=style&index=0&id=52b7bbbc&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52b7bbbc",
  null
  
)

export default component.exports